/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 16,
        viewBox: "0 0 18 16",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M5.63 7.43c0 1.3-1.03 2.35-2.31 2.35a2.33 2.33 0 0 1-2.31-2.35z",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeMiterlimit: 10,
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "m1.01 7.43 2.36-3.96 2.26 3.96",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeMiterlimit: 10,
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M16.99 7.43c0 1.3-1.03 2.35-2.31 2.35a2.33 2.33 0 0 1-2.31-2.35z",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeMiterlimit: 10,
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "m12.37 7.43 2.36-3.96 2.26 3.96",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeMiterlimit: 10,
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M9.02 1v12.88",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeMiterlimit: 10,
                strokeLinecap: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M6.97 13.9h4.1c.93 0 1.69.76 1.69 1.7V16H5.29v-.38c0-.95.75-1.72 1.68-1.72",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M9 .93S7.28 2.72 3.37 2.47",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeMiterlimit: 10,
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M9.05.93s1.72 1.79 5.64 1.54",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeMiterlimit: 10,
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
